import React from 'react';
import { Luggage, Bus } from 'lucide-react';
import Feature from "../Assets/facility-bg.png"

const FeaturesSection = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 py-12 md:p-8">
      <div className="max-w-7xl w-full flex flex-col lg:flex-row items-center gap-8 md:gap-12">
        {/* Left Side - Image */}
        <div className="flex-1 flex justify-center w-full">
          <div className="w-full max-w-md aspect-square bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg flex items-center justify-center">
           <img src={Feature} alt="Features" className="w-full h-full object-cover rounded-lg shadow-lg" />
          </div>
        </div>

        {/* Right Side - Content */}
        <div className="flex-1 w-full">
          {/* Badge */}
          <div className="inline-block mb-4 md:mb-6">
            <span className="px-4 py-2 md:px-6 border-2 border-yellow-500 text-orange-500 rounded-full text-xs md:text-sm font-medium" style={{ color: 'rgba(65, 1, 150, 1)' }}>
              Shree Puja Travels
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6 leading-tight">
            Our Features and<br />Facilities
          </h1>

          {/* Description */}
          <p className="text-sm md:text-base text-gray-600 mb-8 md:mb-12 leading-relaxed">
            <span className="text-cyan-500 font-medium"  style={{ color: 'rgba(65, 1, 150, 1)' }}>We are the creators of India's 1st comfort of branded buses</span>{' '}
            <span className="text-gray-900">that guarantee safe & comfortable journeys.</span> We offer you a complete end-to-end travel experience with our professional crew, round the clock command centre and many other facilities.
          </p>

          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {/* Feature 1 - Comfy Sleepers */}
            <div className="flex flex-col items-start">
              <div className="w-12 h-12 md:w-16 md:h-16 mb-3 md:mb-4 flex items-center justify-center">
                <svg className="w-full h-full text-cyan-500" style={{ color: 'rgba(65, 1, 150, 1)' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="3" y="11" width="18" height="10" rx="2" />
                  <path d="M7 11V7a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4" />
                  <circle cx="7" cy="16" r="1" />
                  <line x1="3" y1="16" x2="21" y2="16" />
                </svg>
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1 md:mb-2">Comfort</h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
Your trip history and data are encrypted and protected. We don't sell your travel data.              </p>
            </div>

            {/* Feature 2 - Luggage Handling */}
            <div className="flex flex-col items-start">
              <div className="w-12 h-12 md:w-16 md:h-16 mb-3 md:mb-4 flex items-center justify-center">
                <Luggage className="w-full h-full text-cyan-500" style={{ color: 'rgba(65, 1, 150, 1)' }} strokeWidth="1.5" />
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1 md:mb-2">Luggage Handling</h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
                Personalized luggage handling by trained staff
              </p>
            </div>

            {/* Feature 3 - Bus Captain */}
            <div className="flex flex-col items-start">
              <div className="w-12 h-12 md:w-16 md:h-16 mb-3 md:mb-4 flex items-center justify-center">
                <svg className="w-full h-full text-cyan-500" style={{ color: 'rgba(65, 1, 150, 1)' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="5" y="5" width="14" height="14" rx="2" />
                  <path d="M9 9h6M9 13h6" />
                  <circle cx="12" cy="18" r="1" />
                  <path d="M19 17v2M5 17v2" />
                  <circle cx="8" cy="11" r="1" />
                  <circle cx="16" cy="11" r="1" />
                </svg>
              </div>
              <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1 md:mb-2">Driver Captain</h3>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
                Professional Driver captain will assist you through the journey
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;